module.exports = __webpack_public_path__ + "static/media/iconLogout.e1a6f812.svg";